export const handleTopScroll = () => {
  const id = document.getElementById("topScrool");

  id.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const handleChatBottomScroll = () => {
  const id = document.getElementById("chatbotScrool");

  if (id) {
    id.scrollTo({
      top: id.scrollHeight, // Scroll to the bottom
      behavior: "smooth", // Smooth scrolling effect
    });
  } else {
    console.error("Element with id 'chatbotScrool' not found.");
  }
};

export const truncateText = (text, wordLimit) => {
  const words = text?.split(" ");
  return words?.length > wordLimit
    ? words?.slice(0, wordLimit)?.join(" ") + "..."
    : text;
};
